import * as React from "react"
import { cn } from "@/lib/utils/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // base styles
        "file:text-foreground placeholder:text-muted-foreground",
        "dark:bg-input/30 bg-transparent",
        "h-9 w-full min-w-0 rounded-md border border-input px-3 py-1",
        "text-base md:text-sm shadow-xs transition-[color,box-shadow]",
        "outline-none",

        // remove ALL focus effects, keep border same
        "focus:outline-none focus:ring-0 focus:border-input",
        "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-input",

        // disabled
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",

        className
      )}
      {...props}
    />
  )
}

export { Input }
